import React from "react";

import { Box, CssBaseline, ThemeProvider, createTheme } from "@mui/material";

import EditShortVideo from "../modules/EditShortVideo";

const editorDarkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#4fc3f7",
    },
    background: {
      default: "#161616",
      paper: "#1c2028",
    },
    divider: "rgba(255,255,255,0.08)",
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: "rgba(255,255,255,0.25)",
        },
        root: {
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255,255,255,0.5)",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#4fc3f7",
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: "rgba(255,255,255,0.5)",
        },
      },
    },
  },
});

function EditShortVideoPage() {
  return (
    <ThemeProvider theme={editorDarkTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <EditShortVideo />
      </Box>
    </ThemeProvider>
  );
}

export default EditShortVideoPage;
